import { WithStyles, withStyles } from '@mui/styles';

import { LockedUser } from './lockedUser';
import { muiStyles } from './styles';

export type LockedUserProps = WithStyles<typeof muiStyles>;

export default withStyles(muiStyles)(LockedUser);